module.exports = __webpack_public_path__ + "media/images/icons/media-record-7130cd14e8cf2973093efc2adc268016.svg";